import React from "react";
import ControllerBimerAnimatedBackground from "./bimer/ControllerBimerAnimatedBackground";
import OrtivisBoardGame from "./ortivis/OrtivisBoardGame";
import BackgroundIserba from "./iserba/BackgroundIserba";

const QuizWrapper = ({
	quizWrapper,
	quizOrganizationId,
	triggerQuestionAnimation,
	room,
	onMoveComplete,
}) => {
	return (
		<div className="absolute top-0 min-h-screen w-full flex justify-center items-center bg-gray-500">
			{quizOrganizationId === "85eff454-0a92-4d87-82e3-564df23f292f" && (
				<ControllerBimerAnimatedBackground
					triggerQuestionAnimation={triggerQuestionAnimation}
				/>
			)}
			{quizOrganizationId === "2f116da7-d51e-459d-8e05-2b2bcc8d0723" && (
				<OrtivisBoardGame room={room} onMoveComplete={onMoveComplete} />
			)}
			{quizOrganizationId === "1af3a66b-316d-4be0-8332-eb7bc15f4e27" && (
				<BackgroundIserba />
			)}
		</div>
	);
};

export default QuizWrapper;
